import { create } from 'zustand'

export const useCatStore = create((set) => ({
    cat : "",
    allCats : ["","other","sport","politics","tech","crypto","economy"],
    updateCat: (newCat) => set(() => ({ cat: newCat })),
    clearCat: () => set({ cat : "" }),
}))
